interface IconProps {
    name: string
    size?: number | string
    className?: string
    color?: string
    'aria-label'?: string
}

export function Icon({
    name,
    size,
    className = '',
    color,
    'aria-label': ariaLabel,
}: IconProps) {
    const url = `${import.meta.env.BASE_URL}assets/icons/${name}.svg`
    const dimension = typeof size === 'number' ? `${size}px` : size

    return (
        <span
            className={`inline-block shrink-0 ${size === undefined ? 'w-6 h-6' : ''} ${className}`}
            role={ariaLabel ? 'img' : undefined}
            aria-label={ariaLabel}
            aria-hidden={!ariaLabel}
            style={{
                width: dimension,
                height: dimension,
                backgroundColor: color ?? 'currentColor',
                WebkitMask: `url(${url}) no-repeat center / contain`,
                mask: `url(${url}) no-repeat center / contain`,
            }}
        />
    )
}

export default Icon